var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data.text),function(item,index){return _c('span',{key:index},[(item.name === 'text')?_c('span',{staticClass:"text-box"},[_vm._v(_vm._s(item.text))]):_c('img',{staticClass:"text-img",attrs:{"src":item.src}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }